import { useState } from "react";
import { toast } from "sonner";
import { api, errorText } from "@/lib/api";
import { Loader2 } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

const field =
  "w-full mt-2 border-0 border-b border-slate-300 px-0 py-2.5 bg-transparent focus:outline-none focus:border-teal text-navy text-sm";

export const PasswordDialog = ({ open, onClose }) => {
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [saving, setSaving] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await api.post("/auth/change-password", { current_password: current, new_password: next });
      toast.success("Password updated.");
      setCurrent("");
      setNext("");
      onClose();
    } catch (err) {
      toast.error(errorText(err.response?.data?.detail) || err.message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="rounded-none border-navy/10 max-w-sm" data-testid="admin-password-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl text-navy">Change password</DialogTitle>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-5 mt-2">
          <div>
            <label className="text-[10px] uppercase tracking-[0.2em] text-slate-500">Current password</label>
            <input data-testid="current-password-input" type="password" value={current} onChange={(e) => setCurrent(e.target.value)} className={field} />
          </div>
          <div>
            <label className="text-[10px] uppercase tracking-[0.2em] text-slate-500">New password (min 8 chars)</label>
            <input data-testid="new-password-input" type="password" value={next} onChange={(e) => setNext(e.target.value)} className={field} />
          </div>
          <button
            type="submit"
            disabled={saving}
            data-testid="save-password-button"
            className="btn-sheen w-full inline-flex items-center justify-center gap-2 bg-navy text-white py-3 text-[11px] uppercase tracking-[0.2em] hover:bg-teal transition-colors disabled:opacity-60"
          >
            {saving && <Loader2 size={14} className="animate-spin" />} Update Password
          </button>
        </form>
      </DialogContent>
    </Dialog>
  );
};
